// Packages and components
import React from 'react';
import { StyledLogoButton } from './SHDLogoButton.styles';

// Helpers and utlities

// Types
import type { SHDLogoButtonProps } from './SHDLogoButton.d';

const SHDLogoButton: React.FC<SHDLogoButtonProps> = ({
  className = 'button-logo',
  logo,
  label,
  onClick,
}) => {
  return (
    <StyledLogoButton
      className={className}
      icon={logo}
      label={label}
      onClick={onClick}
    />
  );
};

export default SHDLogoButton;
